import {Module} from 'vuex';
import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';
import {BriefState} from '@/brief-hub/store/modules/brief/types';
import {StoreState} from '@/brief-hub/store/state/StoreState';
import {v4 as uuidv4} from 'uuid';

export const state: BriefState = {
    loading: false,
    error: false,
    savedNotification: false,
    brief: null,
    payload: null,
    briefForm: {
        jobTitle: null,
        skills: null,
        whenConditions: null,
        whereConditions: null,
        missionTitle: null,
        missionDescription: null,
        identity: null,
        profileDetails: null,
    },
    originReferrer: null,
    briefFunnelId: uuidv4(),
    informationModalDisplayed: false,
};

export const brief: Module<BriefState, StoreState> = {
    state,
    mutations,
    actions,
    getters,
};
